import React, { useState } from 'react'
import { AppBar, Button, IconButton, Stack, Tooltip, Typography, styled } from '@mui/material'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Email, Telegram, Twitter } from '@mui/icons-material'
import Image from 'next/image'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useWallet } from '../WalletContext'
import styles from './styles'
import Popover from './Popover'
import ConnectWalletButton from './ConnectWalletButton'

import { ReactComponent as MediumSvg } from '@/assets/imgs/medium.svg'

import LogoSvg from '@/assets/imgs/logo.svg'
import { toSmallAddr } from '@/utils'
import { HEADER_LINKS } from '@/constants/links'

const TextLogo = styled(Typography)`
  font-weight: 400;
  font-size: 17.4545px;
  line-height: 23px;
  color: #bfff0b;
`
const MenuTitle = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  color: #ffffff;
  cursor: pointer;
`

const StyledIconButton = styled(IconButton)`
  opacity: 0.4;
  :hover {
    opacity: 1;
  }
`

const StyledAddress = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
`

const Header: React.FC = () => {
  const router = useRouter()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const { address, isConnected } = useWallet()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const open = Boolean(anchorEl)

  return (
    <AppBar sx={styles.root}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack direction={'row'} spacing={60}>
          <Link href="https://multibit.exchange/" target="_blank">
            <Stack direction={'row'} spacing={10} alignItems={'center'}>
              <Image src={LogoSvg} alt={'logo'} width={32} height={32} />
              <TextLogo variant="h1">MultiBit</TextLogo>
            </Stack>
          </Link>

          <Stack direction={'row'} spacing={40} alignItems={'center'}>
            {HEADER_LINKS.map((item) => {
              if (item.href) {
                return (
                  <Link key={item.title} target={item.href.includes('http') ? '_blank' : '_self'} href={item.href}>
                    <MenuTitle
                      sx={{
                        opacity: typeof item.href === 'string' && router.pathname === item.href ? 1 : 0.4,
                      }}
                    >
                      {item.title}
                    </MenuTitle>
                  </Link>
                )
              } else {
                return (
                  <Tooltip title="Coming soon" enterTouchDelay={50} key={item.title}>
                    <MenuTitle
                      sx={{
                        opacity: 0.4,
                      }}
                    >
                      {item.title}
                    </MenuTitle>
                  </Tooltip>
                )
              }
            })}
          </Stack>
        </Stack>

        <Stack direction={'row'} spacing={20} alignItems={'center'}>
          <Stack direction={'row'} spacing={4}>
            <Link href="mailto:info@multibit.exchange" target="_blank">
              <StyledIconButton>
                <Email />
              </StyledIconButton>
            </Link>
            <Link href="https://twitter.com/Multibit_Bridge" target="_blank">
              <StyledIconButton>
                <Twitter />
              </StyledIconButton>
            </Link>
            <Link href="https://medium.com/@Multibit_Bridge" target="_blank">
              <StyledIconButton>
                <MediumSvg />
              </StyledIconButton>
            </Link>
            <Link href="https://t.me/multibitprotocol" target="_blank">
              <StyledIconButton>
                <Telegram />
              </StyledIconButton>
            </Link>
          </Stack>

          <Stack direction={'row'} spacing={20}>
            <ConnectWalletButton />

            {isConnected && (
              <Button
                sx={{
                  width: 158,
                  height: 44,
                  backgroundColor: '#000000',
                  boxSizing: 'border-box',
                  borderWidth: 1,
                  borderStyle: 'solid',
                  borderColor: open ? '#fff' : 'rgba(255, 255, 255, 0.2)',
                  '&:hover': { borderColor: 'rgba(255, 255, 255, 0.7)' },
                }}
                disableRipple
                onClick={handleClick}
              >
                <StyledAddress>{toSmallAddr(address)}</StyledAddress>
                <ExpandMoreIcon sx={{ color: '#fff', ml: 6 }} />
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>

      <Popover
        anchorEl={anchorEl}
        handleClose={() => {
          setAnchorEl(null)
        }}
      />
    </AppBar>
  )
}

export default Header
